import { Exclude, Type, Expose } from 'class-transformer';
import { Trait } from 'api/query/shared';

@Exclude()
export class GroupTraitCategory {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  description: string;

  @Expose()
  @Type(() => Trait)
  traits: Trait[];
}
